export const FETCH_SYSTEM = 'system/FETCH_SYSTEM'
export const SET_ERROR = 'system/SET_ERROR'
export const SET_IS_PROD = 'system/SET_IS_PROD'
export const SET_RANGES = 'system/SET_RANGES'

export enum ERROR_TYPES {
  'INFORMATION' = 'information',
  'ERROR' = 'error',
  'WARNING' = 'warning',
}
